import {
  initialState,
  Actions,
  State,
  REGISTER_VIEW,
  REGISTER_VIEW_SUCCESS,
  REGISTER_VIEW_ERROR,
  RESET_REGISTER_VIEW,
} from "../../types/post-views/register-view";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case REGISTER_VIEW:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case REGISTER_VIEW_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case REGISTER_VIEW_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_REGISTER_VIEW:
      return initialState;
    default:
      return state;
  }
};

export default reducers;

